/**
 * 일반건강진단 기본정보(HEA_BASIC_01) 컬럼 정의
 * HEA_BASIC_01 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 일반건강진단 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 본부 컬럼 (편집불가)
    CreateColumn(
      'depNm1',
      '본부',
      'left',
      130,
      false,
      false,
      false,
      'text',
      {
        tooltip: '성명 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 부서 컬럼 (편집불가)
    CreateColumn(
      'depNm2',
      '부서',
      'left',
      130,
      false,
      false,
      false,
      'text',
      {
        tooltip: '성명 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 팀 컬럼 (편집불가)
    CreateColumn('depNm3', '팀', 'left', 130, false, false, false, 'text', {
      tooltip: '성명 선택 시 자동 입력됩니다.',
      cellClass: 'none-editable-cell',
    }),
    // 파트 컬럼 (편집불가)
    CreateColumn('depNm4', '파트', 'left', 130, false, false, false, 'text', {
      tooltip: '성명 선택 시 자동 입력됩니다.',
      cellClass: 'none-editable-cell',
    }),
    // 직책 컬럼 (편집불가)
    CreateColumn(
      'position',
      '직책',
      'left',
      100,
      false,
      false,
      false,
      'text',
      {
        tooltip: '성명 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 사용자ID 컬럼 (숨김)
    CreateColumn('hcId', '사용자ID', 'left', 110, false, false, true, 'text', {
      minWidth: 110,
    }),
    // 성명 컬럼 (필수, requiredButton 타입)
    CreateColumn(
      'name',
      '성명',
      'center',
      130,
      false,
      true,
      false,
      'requiredButton',
      {
        buttonClickHandler: (params) => {
          if (params.data?.newYn === 'Y') {
            props.PopupClickEvent1?.(params);
          }
        },
        buttonEmptyText: '설정하기',
        buttonEmptyTooltip: '성명은 필수입니다.',
        buttonValueTooltip: (params) => {
          const isNew = params.data?.newYn === 'Y';
          return isNew
            ? '재설정 시 클릭하세요.'
            : '저장된 데이터는 수정할 수 없습니다.';
        },
        cellClassRules: {
          'required-cell': (params) => {
            const value = params.value;
            if (typeof value === 'string') {
              return value.trim() === '';
            }
            if (typeof value === 'number') {
              return false;
            }
            return !value;
          },
          'none-editable-cell': (params) => {
            // 편집 불가일 때 none-editable-cell 클래스 적용
            return params.data?.newYn !== 'Y';
          },
        },
      }
    ),
    // 검진주기(년) 컬럼 (필수, select)
    CreateColumn(
      'hcCycle',
      '검진주기(년)',
      'center',
      130,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['1', '2'],
        headerComponentParams: {
          required: true,
          template:
            '<div class="ag-header-cell-label"><span style="color: red; margin-right: 4px;">*</span><span>검진주기(년)<br>(사무직 2년,<br>비사무직 1년)</span></div>',
        },
      }
    ),
    // 검진일 컬럼 (필수, date)
    CreateColumn('hcDate', '검진일', 'center', 120, true, true, false, 'date', {}),
    // 유효일자 컬럼 (필수, 편집불가)
    CreateColumn(
      'hcEffeDate',
      '유효일자',
      'center',
      120,
      false,
      true,
      false,
      'date',
      {
        tooltip: '검진일과 검진주기로 자동 계산됩니다.',
        cellClass: 'none-editable-cell',
      }
    ),
    // 알람여부 (Y/N) 컬럼 (필수, select)
    CreateColumn(
      'hcAlarmYn',
      '알람여부 (Y/N)',
      'center',
      130,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['Y', 'N'],
      }
    ),
    // 검진기관 컬럼 (필수, text)
    CreateColumn(
      'hcCheckupCenter',
      '검진기관',
      'left',
      200,
      true,
      true,
      false,
      'text',
      {
        maxLength: 100,
      }
    ),
    // 검진표 첨부 컬럼 (필수, fileButton)
    CreateColumn(
      'hcCheckupAttachmentFileName',
      '검진표 첨부',
      'center',
      200,
      false,
      true,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupFileClickEvent?.(data, 'hcCheckupFile');
        },
      }
    ),
    // 사후관리조치 첨부 컬럼 (필수, fileButton)
    CreateColumn(
      'hcPostcareAttachmentFileName',
      '사후관리조치 첨부',
      'center',
      220,
      false,
      true,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupFileClickEvent?.(data, 'hcPostcareFile');
        },
      }
    ),
    // 비고 컬럼
    CreateColumn('hcRemark', '비고', 'left', 200, true, false, false, 'text', {
      maxLength: 200,
    }),
    // ALARM_ID 컬럼 (숨김)
    CreateColumn('alarmId', 'ALARM_ID', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
  ];
};

/**
 * 특수건강진단 관련 컬럼 정의
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = () => {
  return [
    CreateColumn('hcId', '사용자ID', 'left', 130, false, false, false, 'text'),
    CreateColumn(
      'hcSubstance',
      '취급물질',
      'left',
      200,
      true,
      false,
      false,
      'text'
    ),
    CreateColumn('hcNoise', '소음작업', 'left', 130, true, false, false, 'text'),
    CreateColumn('hcNight', '야간작업', 'left', 130, true, false, false, 'text'),
    CreateColumn(
      'hcGubun',
      '건강검진(특수,일반)',
      'center',
      150,
      true,
      false,
      false,
      'select',
      {
        selectOptions: ['특수', '일반'],
        cellEditor: 'agSelectCellEditor',
      }
    ),
    CreateColumn(
      'hcCycle',
      '검진주기',
      'center',
      130,
      true,
      false,
      false,
      'select',
      {
        selectOptions: [
          '1달',
          '2달',
          '3달',
          '4달',
          '5달',
          '6달',
          '7달',
          '8달',
          '9달',
          '10달',
          '11달',
          '1년',
        ],
        cellEditor: 'agSelectCellEditor',
      }
    ),
    CreateColumn('hcDate', '검진일', 'center', 130, true, false, false, 'date', {
    }),
    CreateColumn(
      'hcEffeDate',
      '유효일자',
      'center',
      130,
      true,
      false,
      false,
      'date',
      {}
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
